import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "../ui/alert-dialog";
import { DrillUsageNotice } from "./DrillUsageNotice";

// Confirm deleting one question; lists the drills it belongs to before the admin commits.
export const DeleteQuestionDialog = ({ question, onOpenChange, onConfirm }) => (
  <AlertDialog open={!!question} onOpenChange={(v) => { if (!v) onOpenChange(null); }}>
    <AlertDialogContent data-testid="delete-question-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete this question?</AlertDialogTitle>
        <AlertDialogDescription>
          {question?.title ? <><strong className="text-foreground">{question.title}</strong> — </> : null}
          this permanently deletes the question and any schedules for it. This can't be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      {question && <DrillUsageNotice questionIds={[question.question_id]} />}
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="delete-question-cancel">Cancel</AlertDialogCancel>
        <AlertDialogAction onClick={() => { const q = question; onOpenChange(null); onConfirm(q.question_id); }} className="bg-destructive text-destructive-foreground hover:bg-destructive/90" data-testid="delete-question-confirm">
          Delete question
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
